<template>
    <div class="recipe--rating-container">
        <strong>Betyg</strong>
        <div class="recipe--rating">
            <span class="recipe--rating-result" :style="'width:' + getRatingScore(150) + 'px'"></span>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import state from './../state.js';

export default {
    props: ['ratingScore', 'recipeId', 'userId'],

    data() {
        return {
            state,
            ratings: [1, 2, 3, 4, 5],
            recipeRating: []
        };
    },

    mounted() {
        this.getRating();
    },

    methods: {
        setRating() {},

        getRating() {
            axios
                .get('/recept/api/ratings?recipe_id=' + this.recipeId)
                .then((response) => {
                    this.recipeRating = response.data;
                    this.getRatingScore();
                })
                .catch((error) => {
                    console.log('get error', error);
                });
        },

        getRatingScore(width) {
            const ratingScore = this.recipeRating.reduce((sum, value) => sum + value['rating'], 0);
            const ratingMaxScore = this.recipeRating.length * 5;
            const avgRatingScore = ratingScore / ratingMaxScore;

            return avgRatingScore * width;
        }
    }
};
</script>
